import { Box, Grid } from "@mui/material"
import { useSelector } from "react-redux"
import theme from "theme"

export const DetailDevice = ({ t }) => {
    const detailDevice = useSelector((state) => state.mcu.detailDevice)

    return <Box>
        <Box sx={{ fontWeight: '600', lineHeight: '36px' }}>
            {t('mcu.detailDevice.info')} <span style={{ fontWeight: '700' }}>{detailDevice.name}</span>
        </Box>
        <Grid container columnSpacing={{ xs: 2 }}>
            <Grid item xs={2} sx={{ lineHeight: '36px', textAlign: 'right' }}>
                {t('mcu.table.deviceCode')}
            </Grid>
            <Grid item xs={10} sx={{ lineHeight: '36px', fontWeight: '500' }}>
                {detailDevice.code}
            </Grid>
            <Grid item xs={2} sx={{ lineHeight: '36px', textAlign: 'right' }}>
                {t('mcu.table.brand')}
            </Grid>
            <Grid item xs={10} sx={{ lineHeight: '36px', fontWeight: '500' }}>
                {detailDevice.vendor}
            </Grid>
            <Grid item xs={2} sx={{ lineHeight: '36px', textAlign: 'right' }}>
                {t('mcu.table.model')}
            </Grid>
            <Grid item xs={10} sx={{ lineHeight: '36px', fontWeight: '500' }}>
                {detailDevice.model}
            </Grid>
            <Grid item xs={2} sx={{ lineHeight: '36px', textAlign: 'right' }}>
                {t('mcu.table.serial')}
            </Grid>
            <Grid item xs={10} sx={{ lineHeight: '36px', fontWeight: '500' }}>
                {detailDevice.serial_number}
            </Grid>
            {/* --------- */}
            <Grid item xs={2} sx={{ lineHeight: '36px', textAlign: 'right' }}>
                {t('mcu.table.room')}
            </Grid>
            <Grid item xs={10} sx={{ lineHeight: '36px', fontWeight: '500' }}>
                {detailDevice.preferred_room_number}
            </Grid>
            <Grid item xs={2} sx={{ lineHeight: '36px', textAlign: 'right' }}>
                {t('mcu.table.roomName')}
            </Grid>
            <Grid item xs={10} sx={{ lineHeight: '36px', fontWeight: '500' }}>
                {detailDevice.preferred_room_name}
            </Grid>
            {/* <Grid item xs={3}></Grid> */}
            {/* --------- */}
            <Grid item xs={2} sx={{ lineHeight: '36px', textAlign: 'right' }}>
                {t('mcu.table.sipAccount')}
            </Grid>
            <Grid item xs={10} sx={{ lineHeight: '36px', fontWeight: '500' }}>
                {detailDevice.sip_account}
            </Grid>
            <Grid item xs={2} sx={{ lineHeight: '36px', textAlign: 'right' }}>
                {t('mcu.table.hostServer')}
            </Grid>
            <Grid item xs={10} sx={{ lineHeight: '36px', fontWeight: '500' }}>
                {detailDevice.sip_account ? detailDevice.sip_account.split("@")[1] : ''}
            </Grid>
            {/* <Grid item xs={3}></Grid> */}
            {/* --------- */}
            <Grid item xs={2} sx={{ lineHeight: '36px', textAlign: 'right' }}>
                {t('mcu.table.ip')}
            </Grid>
            <Grid item xs={10} sx={{ lineHeight: '36px', fontWeight: '500' }}>
                {detailDevice.mgmt_ip}
            </Grid>
            <Grid item xs={2} sx={{ lineHeight: '36px', textAlign: 'right' }}>
                {t('mcu.table.port')}
            </Grid>
            <Grid item xs={10} sx={{ lineHeight: '36px', fontWeight: '500' }}>
                {detailDevice.mgmt_port}
            </Grid>
            {/* <Grid item xs={3}></Grid> */}
            {/* --------- */}
            <Grid item xs={2} sx={{ lineHeight: '36px', textAlign: 'right' }}>
                {t('mcu.table.link')}
            </Grid>
            <Grid item xs={10} sx={{ lineHeight: '36px', fontWeight: '500', color: theme.palette.primary.main, textDecoration: 'underline' }}>
                {detailDevice.mgmt_url}
            </Grid>
        </Grid>
    </Box>
}